import { Routes, Route } from 'react-router-dom';
import LoadingSplashPage from './pages/LoadingSplashPage';
import { LoginEmailPage, LoginEmailSentPage } from './pages/login';
import LoginV2 from './pages/login/LoginV2';
import HomeV2Page from './pages/HomeV2Page';
import ActivityDetailsPage from './pages/ActivityDetailsPage';
import ActivityLibraryPage from './pages/ActivityLibraryPage';
import LibraryPage from './pages/LibraryPage';
import { FilterProvider } from './contexts';
import ExpertTipsPage from './pages/ExpertsTipsPage';
import JourneyPage from './pages/JourneyPage';
import VerifyMagicLinkPage from './pages/VerifyMagicLinkPage';
import ProtectedRoute from './components/ProtectedRoute';
import CheckInSplashPage from './pages/check-in/CheckInSplashPage';
import CheckInWeatherPage from './pages/check-in/CheckInWeatherPage';
import CheckInSubEmotionsPage from './pages/check-in/CheckInSubEmotionsPage';
import CheckInStrategyListPage from './pages/check-in/CheckInStrategyListPage';
import CheckInStrategyDetailPage from './pages/check-in/CheckInStrategyDetailPage';
import CheckInCompletedPage from './pages/check-in/CheckInCompletedPage';
import ChildDetailsPage from './pages/ChildDetailsPage';
import AssessmentPage from './pages/AssessmentPage';
import AssessmentCompletedPage from './pages/AssessmentCompletedPage';
import ChildProfilePage from './pages/ChildProfilePage';
import CategoryDetailPage from './pages/CategoryDetailPage';
import SplashTestPage from './pages/SplashTestPage';


function App() {
  return (
    <FilterProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoadingSplashPage />} />
        <Route path="/test/splash" element={<SplashTestPage />} />
        <Route path="/login" element={<LoginV2 />} />
        <Route path="/login/email" element={<LoginEmailPage />} />
        <Route path="/login/email-sent" element={<LoginEmailSentPage />} />
        {/* <Route path="/auth" element={<LoginLandingPage />} /> */}
        <Route path="/verify-magic-link" element={<VerifyMagicLinkPage />} />
        <Route path="/activity/:id" element={<ActivityDetailsPage />} />
        {/* Protected routes - require authentication */}
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<HomeV2Page />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/library/all" element={<ActivityLibraryPage />} />
          <Route path="/expert-tips" element={<ExpertTipsPage />} />
          <Route path="/journey" element={<JourneyPage />} />
          <Route path="/journey/child/new" element={<ChildDetailsPage />} />
          <Route path="/assessment/:childId" element={<AssessmentPage />} />
          <Route path="/assessment/:childId/completed" element={<AssessmentCompletedPage />} />
          <Route path="/profile/:childId" element={<ChildProfilePage />} />
          <Route path="/profile/:childId/category/:categoryId" element={<CategoryDetailPage />} />
          <Route path="/check-in" element={<CheckInSplashPage />} />
          <Route path="/check-in/weather" element={<CheckInWeatherPage />} />
          <Route path="/check-in/completed" element={<CheckInCompletedPage />} />
          <Route path="/check-in/strategies/:id" element={<CheckInStrategyDetailPage />} />
          <Route path="/check-in/:category/strategies" element={<CheckInStrategyListPage />} />
          <Route path="/check-in/:category" element={<CheckInSubEmotionsPage />} />
        </Route>
      </Routes>
    </FilterProvider>
  );
}

export default App;
